import moment from 'moment';
import { QNote, yupValidateSync } from '@qwealth/qdata';
import { validateDate } from '@qwealth/kyc';
import { SortDirection } from '../models/SortDirection';
import { getRootPath } from '@qwealth/qvault';

const dateValidator = (field: string, label: string, date?: string): string | undefined =>
  yupValidateSync(
    date,
    validateDate(field, date)
      .test(field, `${label} cannot be greater than today's date`, () => moment(date).isBefore(moment()))
      .nullable()
      .required(`${label} is required`),
  );

export const validateDateRange = (fromDate?: string, toDate?: string): string | undefined => {
  const fromDateValidation = dateValidator('fromDate', 'From Date', fromDate);
  const toDateValidation = dateValidator('toDate', 'To Date', toDate);
  const rangeValidation = moment(fromDate).isAfter(toDate) ? 'To Date cannot be before From Date' : undefined;

  return fromDateValidation || toDateValidation || rangeValidation;
};

export const qNoteDateComparator =
  (sortDirection: SortDirection) =>
  (a: QNote, b: QNote): number => {
    const diff = moment(b.date).diff(a.date);
    const directionMultiplier = sortDirection === 'ASC' ? -1 : 1;
    return directionMultiplier * diff;
  };

export const getQnoteAttachmentPath = (householdId: string, id: number | string): string => {
  const rootPath = getRootPath(householdId, true);
  return `${rootPath}/QNote Attachments/${id}/`;
};
